import React from 'react'
import { Rating, Typography } from '@mui/material';
import styles from './GoogleRating.module.scss';
import { Star, StarBorder } from '@mui/icons-material';
import googleLogo from '../../../../images/G_logo.svg';

export const DEFAULT_GOOGLE_RATING = 4.5;
export const DEFAULT_GOOGLE_REVIEWS_COUNT = 812;

interface GoogleRatingProps {
  rating?: number;
  reviews?: number;
}

const GoogleRating = ({
  rating = DEFAULT_GOOGLE_RATING,
  reviews = DEFAULT_GOOGLE_REVIEWS_COUNT,
}: GoogleRatingProps) => {
  return (
    <div className={styles.googleRating} style={{ 
      marginTop: '0.5rem',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <img src={googleLogo} alt="Google Logo" className={styles.googleLogo} />
      <div>
        <div className={styles.ratingStars}>
          <Typography 
            component="span" 
            sx={{ 
              fontSize: '0.875rem',
              fontWeight: 600,
              marginRight: '0.5rem',
              '@media (min-width: 768px)': { fontSize: '1rem' },
              '@media (min-width: 901px)': { fontSize: '1rem' }
            }}
          >
            {rating}
          </Typography>
          <Rating
            name="googleRating"
            value={rating}
            readOnly
            precision={0.25}
            emptyIcon={<StarBorder className={styles.starIconInactive} />}
            icon={<Star className={styles.starIconActive} />}
          />
        </div>
        <Typography 
          component="span" 
          sx={{ 
            fontSize: '0.75rem',
            color: '#666',
            '@media (min-width: 768px)': { fontSize: '0.875rem' },
            '@media (min-width: 901px)': { fontSize: '0.875rem' }
          }}
        >
          {reviews}+ Reviews
        </Typography>
      </div>
    </div>
  );
};

export default GoogleRating;
